import { PlatformType } from "../models/Platform";

export const PINTEREST_CAPTION_LIMIT = 800;

export function shortenCaption(caption: string, limit: number): string {
  if (limit <= 0) return "";
  if (caption.length <= limit) return caption;

  const suffix = "...";
  if (limit <= suffix.length) return caption.slice(0, limit);

  const contentLimit = limit - suffix.length;
  const minimumBoundary = Math.floor(contentLimit * 0.85);
  let boundary = contentLimit;

  while (boundary > minimumBoundary && !/\s/.test(caption[boundary])) {
    boundary -= 1;
  }

  if (boundary <= minimumBoundary) {
    boundary = contentLimit;
  }

  return `${caption.slice(0, boundary).trimEnd()}${suffix}`;
}

export function getInheritedPlatformDescription(
  platform: PlatformType,
  postDescription: string
): string {
  if (platform === "pinterest") {
    return shortenCaption(postDescription, PINTEREST_CAPTION_LIMIT);
  }

  return postDescription;
}

export function getEffectivePlatformDescription(
  platform: PlatformType,
  description: string | undefined,
  postDescription: string
): string {
  return description?.trim()
    ? description
    : getInheritedPlatformDescription(platform, postDescription);
}
